import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import { AuthContext } from "../context/AuthContext";

function TermsAcceptanceGuard() {
  const { isLoggedIn, user, setUser, signOut } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const token = user?.token;
  const currentTermsVersion = user?.currentTermsVersion;
  const termsAcceptedVersion = user?.termsAcceptedVersion;
  const requiresTermsAcceptance = !!user?.requiresTermsAcceptance;

  useEffect(() => {
    const syncTermsStatus = async () => {
      if (!isLoggedIn || !token) {
        return;
      }
      try {
        const url = `${process.env.REACT_APP_SC_API_BASE_URL}/api/legal/terms/status`;
        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const requiresAcceptance = !!response.data.requiresAcceptance;
        const latestTermsVersion = response.data.currentTermsVersion;
        const acceptedTermsVersion = response.data.acceptedTermsVersion;
        const shouldUpdateUser =
          currentTermsVersion !== latestTermsVersion ||
          termsAcceptedVersion !== acceptedTermsVersion ||
          requiresTermsAcceptance !== requiresAcceptance;

        if (shouldUpdateUser) {
          setUser((prev) => {
            if (!prev) return prev;
            const merged = {
              ...prev,
              currentTermsVersion: latestTermsVersion,
              termsAcceptedVersion: acceptedTermsVersion,
              requiresTermsAcceptance: requiresAcceptance,
            };
            const cookieUser = { ...merged };
            delete cookieUser.token;
            Cookies.set("user", JSON.stringify(cookieUser), {
              expires: 7,
              secure: true,
              sameSite: "Lax",
            });
            return merged;
          });
        }

        if (requiresAcceptance && location.pathname !== "/terms") {
          navigate("/terms?required=true");
        }
      } catch (error) {
        if (error.response?.status === 401) {
          signOut();
        }
      }
    };

    syncTermsStatus();
  }, [
    isLoggedIn,
    token,
    currentTermsVersion,
    termsAcceptedVersion,
    requiresTermsAcceptance,
    location.pathname,
    navigate,
    setUser,
    signOut,
  ]);

  return null;
}

export default TermsAcceptanceGuard;
